import { DatePreset } from './date-preset.enum';

export const presetDurations: Record<DatePreset, number> = {
  [DatePreset.Today]: 0,
  [DatePreset.TwoDays]: 1,
  [DatePreset.ThreeDays]: 2,
  [DatePreset.OneWeek]: 6,
  [DatePreset.TwoWeeks]: 13,
  [DatePreset.ThreeWeeks]: 20,
};
